export const DEVICE_STATE_COLOR={
"init":"rgba(221,222,250,1)",
"jobRequested":"rgba(188,189,245,1)",
"jobReady":"rgba(125,126,232,1)",
"modelDownload":"rgba(52,53,135,1)",
"training":"rgba(0, 191, 254,1)",
"evaluation":"rgba(0, 191, 254,1)",
"test":"rgba(0, 191, 254,1)",
"complete":"rgba(56,136,255,1)",
"aggout":"rgba(154, 0, 248,1)",
"timeout":"rgba(243, 156, 17,1)",
"fail":"rgba(232, 76, 61,1)",
}

export const DEVICE_STATE_NAME={
"init":"Init",
"jobRequested":"Job Request",
"jobReady":"Job Ready",
"modelDownload":"Model Download",
"training":"Training",
"evaluation":"Evaluation",
"test":"Test",
"complete":"Complete",
"aggout":"Exclude from aggregation",
"timeout":"Timeout",
"fail":"Fail",
}